import { useEffect, useState, useRef } from "react";
import CountUp from "react-countup";
import { motion } from "framer-motion";

const STAT_MOTION = { initial: { opacity: 0, y: 20 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true } };
const STATS = [
  { value: 6588, suffix: " MT", prefix: "", label: "Material Sold", decimals: 0 },
  { value: 100, suffix: " Cr+", prefix: "₹", label: "GMV Run-Rate", decimals: 0 },
  { value: 95, suffix: "%", prefix: "", label: "Repeat Rate", decimals: 0 },
  { value: 21, suffix: " Cr+", prefix: "₹", label: "Revenue FY25-26", decimals: 0 },
];

export function TrustSignals() {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={ref}
      data-testid="trust-signals-section"
      className="py-20 px-6 relative border-y border-ib-steel/10"
    >
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[200px] bg-ib-blue/5 rounded-full blur-[100px]" />
      </div>

      <div className="max-w-5xl mx-auto relative z-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-10">
          {STATS.map((stat, i) => (
            <motion.div
              key={stat.label}
              {...STAT_MOTION}
              transition={{ duration: 0.4, delay: i * 0.1 }}
              className="text-center"
              data-testid={`trust-stat-${stat.label.toLowerCase().replace(/\s/g, "-")}`}
            >
              <div className="font-jetbrains text-2xl sm:text-3xl lg:text-4xl font-bold text-ib-text mb-1">
                {visible && (
                  <CountUp
                    start={0}
                    end={stat.value}
                    duration={2.5}
                    separator=","
                    prefix={stat.prefix}
                    suffix={stat.suffix}
                    decimals={stat.decimals}
                  />
                )}
              </div>
              <div className="font-manrope text-xs sm:text-sm text-ib-text-secondary">{stat.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
